import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { useAirModal } from "@air/provider-modal";
import { memo } from "react";
import { ConnectedSlackChannel } from "./ConnectedSlackChannel";
import { DeleteBoardSlackIntegrationModal } from "./DeleteBoardSlackIntegrationModal";
export const ConnectedToSlack = /*#__PURE__*/ memo((param)=>{
    let { integration, boardId, canManageSlackIntegration } = param;
    const [showDeleteSlackIntegrationModal] = useAirModal(DeleteBoardSlackIntegrationModal);
    return /*#__PURE__*/ _jsxs("div", {
        className: "group/connected-slack-container relative mt-2",
        children: [
            /*#__PURE__*/ _jsx(ConnectedSlackChannel, {
                channelName: integration.channelName
            }),
            canManageSlackIntegration && /*#__PURE__*/ _jsx(Button, {
                appearance: "ghost",
                color: "grey",
                className: "absolute right-2.5 top-1/2 hidden -translate-y-1/2 group-hover/connected-slack-container:block hover:bg-grey-5",
                onClick: ()=>showDeleteSlackIntegrationModal({
                        boardId,
                        integration
                    }),
                children: "Disconnect"
            })
        ]
    });
});
ConnectedToSlack.displayName = "ConnectedToSlack";
